import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { LoadingIndicatorService } from './core/services/loading-indicator.service';
import { TokenRefreshScheduler } from './core/services/token-refresh-scheduler.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, ConfirmDialog],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly loading = inject(LoadingIndicatorService);

  // Root-provided services are lazy; injecting it here starts the background
  // refresh timer that keeps the session alive while the app is open.
  private readonly tokenRefreshScheduler = inject(TokenRefreshScheduler);
}
